export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./new-live-games.vue?vue&type=template&id=8762bae8"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/sport-banners/new-live-games.vue?vue&type=template&id=8762bae8
// module id = twep
// module chunks = 0